export default __webpack_public_path__ + "static/media/stamp_5.e5aa9948.png";